// ─── Login ───────────────────────────────────────────────────────────────────
export const LOGIN_SESSION_START = 'Login_SessionStart';
export const LOGIN_SESSION_END = 'Login_SessionEnd';
export const ACCESS_DENIED = 'Access_Denied';

// ─── View As ─────────────────────────────────────────────────────────────────
export const VIEWAS_SWITCH_USER = 'ViewAs_SwitchUser';
export const VIEWAS_STOP_VIEWING = 'ViewAs_StopViewing';

// ─── Dashboard ───────────────────────────────────────────────────────────────
export const DASHBOARD_PAGE_OPENED = 'Dashboard_PageOpened';
export const DASHBOARD_FILTER_APPLIED = 'Dashboard_FilterApplied';
export const DASHBOARD_WIDGET_TIMERANGE = 'Dashboard_WidgetTimeRange';
export const DASHBOARD_UPDATE_TIME_RANGE = 'Dashboard_UpdateTimeRange';
export const DASHBOARD_CALENDAR_APPLY = 'Dashboard_CalendarApply';
export const DASHBOARD_GRAPH_INTERACTION = 'Dashboard_GraphInteraction';
export const DASHBOARD_GRAPH_EXPAND = 'Dashboard_GraphExpand';
export const DASHBOARD_GRAPH_TYPE_CHANGE = 'Dashboard_GraphTypeChange';
export const DASHBOARD_GRAPH_TIMEFRAME_EDIT = 'Dashboard_GraphTimeframeEdit';
export const DASHBOARD_WIDGET_CLOCK_TOGGLE = 'Dashboard_WidgetClockToggle';
export const DASHBOARD_WIDGET_DOWNLOAD = 'Dashboard_WidgetDownload';
export const DASHBOARD_REFRESH = 'Dashboard_Refresh';
export const DASHBOARD_DOWNLOAD = 'Dashboard_Download';
export const DASHBOARD_AI_WIDGET_OPEN = 'Dashboard_AIWidgetOpen';
export const DASHBOARD_SHARE = 'Dashboard_Share';
export const DASHBOARD_MANAGE = 'Dashboard_ManageDashboard';
export const DASHBOARD_EDIT_PAGE = 'Dashboard_EditPage';
export const DASHBOARD_SAVE = 'Dashboard_Save';
export const DASHBOARD_ADD_WIDGET = 'Dashboard_AddWidget';
export const DASHBOARD_DELETE_PAGE = 'Dashboard_DeletePage';
export const DASHBOARD_CLONE_PAGE = 'Dashboard_ClonePage';
export const DASHBOARD_DELETE_WIDGET = 'Dashboard_DeleteWidget';

// ─── Task ────────────────────────────────────────────────────────────────────
export const TASK_CREATED = 'Task_Created';
export const TASK_DELETED = 'Task_Deleted';
export const TASK_COMPLETED = 'Task_Completed';
export const TASK_TAB_SWITCHED = 'Task_TabSwitched';
export const TASK_FILTER_APPLIED = 'Task_FilterApplied';
export const TASK_ROW_CLICKED = 'Task_RowClicked';
export const ONETIME_TASK_SAVED = 'OneTimeTask_Saved';
export const FIXED_TASK_SAVED = 'FixedTask_Saved';
export const TASK_TEMPLATE_SAVED = 'TaskTemplate_Saved';
export const TASK_TEMPLATE_DELETED = 'TaskTemplate_Deleted';
export const TASK_ATTACHMENT_UPLOADED = 'TaskTemplate_AttachmentUploaded';
export const TASK_TRANSITION = 'Task_Transition';

// ─── Remote Control ──────────────────────────────────────────────────────────
export const REMOTE_CONTROL_ON = 'RemoteControl_On';
export const REMOTE_CONTROL_OFF = 'RemoteControl_Off';
export const REMOTE_CONTROL_MODAL_OPENED = 'RemoteControl_ModalOpened';
export const REMOTE_CONTROL_MODAL_CLOSED = 'RemoteControl_ModalClosed';
export const REMOTE_CONTROL_MODE_CHANGED = 'RemoteControl_ModeChanged';
export const REMOTE_CONTROL_COMMAND_CHANGED = 'RemoteControl_CommandChanged';
export const REMOTE_CONTROL_DURATION_CHANGED = 'RemoteControl_DurationChanged';
export const REMOTE_CONTROL_TIMER_MODIFIED = 'RemoteControl_TimerModified';
export const REMOTE_CONTROL_STATUS_REFRESHED = 'RemoteControl_StatusRefreshed';
export const REMOTE_CONTROL_CONFIG_SAVED = 'RemoteControl_ConfigSaved';

// ─── Insights ────────────────────────────────────────────────────────────────
export const INSIGHTS_VIEW = 'Insights_View';
export const INSIGHTS_CLOSE = 'Insights_Close';
export const INSIGHTS_FILTER_PRIORITY = 'Insights_FilterPriority';
export const INSIGHTS_FILTER_STATUS = 'Insights_FilterStatus';
export const INSIGHTS_MARK_CLOSED = 'Insights_MarkClosed';
export const INSIGHTS_COMMENT_ADDED = 'Insights_CommentAdded';
export const INSIGHTS_CREATED = 'Insights_Created';
export const INSIGHTS_FILTER_ASSET = 'Insights_FilterAsset';
export const INSIGHTS_FILTER_WORKSPACE = 'Insights_FilterWorkspace';
export const INSIGHTS_FILTER_TYPE = 'Insights_FilterType';

// ─── User Module ─────────────────────────────────────────────────────────────
export const USER_MODULE_ADD = 'UserModule_Add';
export const USER_MODULE_EDIT = 'UserModule_Edit';
export const USER_MODULE_DELETE = 'UserModule_Delete';

// ─── Maintenance Calendar / Roster ───────────────────────────────────────────
export const MAINTENANCE_ITEM_OPENED = 'MaintenanceCalendar_ItemOpened';
export const ROSTER_PLAN_SAVED = 'Roster_PlanSaved';
export const ROSTER_SCHEDULE_SAVED = 'Roster_ScheduleSaved';
export const ROSTER_ADDED = 'Roster_Added';
export const ROSTER_DELETED = 'Roster_Deleted';

// ─── Events / Batches ────────────────────────────────────────────────────────
export const EVENT_VIEW = 'Event_View';
export const EVENT_MANUAL_START = 'Event_ManualStart';
export const EVENT_MANUAL_STOP = 'Event_ManualStop';
export const EVENTS_FILTER_APPLIED = 'Events_FilterApplied';
export const EVENT_TEMPLATE_DELETED = 'EventTemplate_Deleted';

// ─── SCADA / Visualization ───────────────────────────────────────────────────
export const VISUALIZATION_EQUIPMENT_CLICK = 'Visualization_EquipmentClick';
export const VISUALIZATION_TIMERANGE_CHANGE = 'Visualization_TimeRangeChange';
export const VISUALIZATION_REMOTE_ON = 'Visualization_RemoteControlOn';
export const VISUALIZATION_REMOTE_OFF = 'Visualization_RemoteControlOff';
export const VISUALIZATION_ELEMENT_ENTERED = 'Visualization_ElementEntered';
export const VISUALIZATION_VIEW = 'Visualization_View';
export const VISUALIZATION_PAGE_SELECTED = 'Visualization_PageSelected';
// ─── Analytical Engine ───────────────────────────────────────────────────────
export const ANALYTICAL_ENGINE_OPEN = 'AnalyticalEngine_Open';
export const FORMULA_SAVED = 'AnalyticalEngine_FormulaSaved';
export const FORMULA_EDITED = 'AnalyticalEngine_FormulaEdited';
export const FORMULA_DUPLICATED = 'AnalyticalEngine_FormulaDuplicated';

// ─── Inventory ───────────────────────────────────────────────────────────────
export const INVENTORY_VALUE_UPDATED = 'Inventory_ValueUpdated';

// ─── Triggers ────────────────────────────────────────────────────────────────
export const TRIGGER_ACTIVATED = 'Trigger_Activated';
export const TRIGGER_DEACTIVATED = 'Trigger_Deactivated';
export const TRIGGER_SAVED = 'Trigger_Saved';
export const TRIGGER_DELETED = 'Trigger_Deleted';
export const TRIGGER_COMPONENT_SAVED = 'Trigger_ComponentSaved';

// ─── DI Input ────────────────────────────────────────────────────────────────
export const DI_INPUT_NEW_VALUE = 'DIInput_NewValue';
export const DI_SEARCH_EQUIPMENT = 'DIInput_SearchEquipment';

// ─── OCR ─────────────────────────────────────────────────────────────────────
export const OCR_IMAGE_PROCESSED = 'OCR_ImageProcessed';
export const OCR_DATA_SUBMITTED = 'OCR_DataSubmitted';

// ─── Tickets ─────────────────────────────────────────────────────────────────
export const TICKET_CREATED = 'Ticket_Created';
export const TICKET_STATUS_CHANGED = 'Ticket_StatusChanged';
export const TICKET_COMMENT_ADDED = 'Ticket_CommentAdded';

// ─── Escalation ──────────────────────────────────────────────────────────────
export const ESCALATION_SAVED = 'Escalation_Saved';
export const ESCALATION_DELETED = 'Escalation_Deleted';

// ─── Communication ───────────────────────────────────────────────────────────
export const COMMUNICATION_FILTER_APPLIED = 'Communication_FilterApplied';
export const COMMUNICATION_OPENED = 'Communication_Opened';

// ─── Notifications ───────────────────────────────────────────────────────────
export const NOTIFICATION_OPENED = 'Notification_Opened';
export const NOTIFICATION_ACTION_TAKEN = 'Notification_ActionTaken';
export const NOTIFICATION_SETTING_CHANGED = 'Notification_SettingChanged';
export const NOTIFICATION_MARKED_READ = 'Notification_MarkedRead';
export const NOTIFICATION_FILTER_APPLIED = 'Notification_FilterApplied';
export const NOTIFICATION_MODULE_SELECTED = 'Notification_ModuleSelected';

// ─── Logbook ─────────────────────────────────────────────────────────────────
export const LOGBOOK_SAVED = 'Logbook_Saved';
export const LOGBOOK_DELETED = 'Logbook_Deleted';

// ─── Workflow ────────────────────────────────────────────────────────────────
export const WORKFLOW_CREATED = 'Workflow_Created';
export const WORKFLOW_DELETED = 'Workflow_Deleted';

// ─── Data Correction ─────────────────────────────────────────────────────────
export const DATA_CORRECTION_SAVED = 'DataCorrection_Saved';

// ─── Batch Config ────────────────────────────────────────────────────────────
export const BATCH_CONFIG_SAVED = 'BatchConfig_Saved';
export const BATCH_CONFIG_DELETED = 'BatchConfig_Deleted';

// ─── Sensor ──────────────────────────────────────────────────────────────────
export const SENSOR_SAVED = 'Sensor_Saved';

// ─── Company / Workspace ─────────────────────────────────────────────────────
export const COMPANY_SAVED = 'Company_Saved';
export const WORKSPACE_SAVED = 'Workspace_Saved';

// ─── Store / Chemical ────────────────────────────────────────────────────────
export const STORE_ITEM_SAVED = 'Store_ItemSaved';
export const CHEMICAL_LOG_SAVED = 'ChemicalLog_Saved';

// ─── File Manager ────────────────────────────────────────────────────────────
export const FILE_UPLOADED = 'FileManager_FileUploaded';

// ─── Profile ─────────────────────────────────────────────────────────────────
export const PROFILE_UPDATED = 'Profile_Updated';

// ─── Sidebar ─────────────────────────────────────────────────────────────────
export const SIDEBAR_NAV_CLICKED = 'Sidebar_NavClicked';

// ─── Generic Lifecycle ───────────────────────────────────────────────────────
export const MODAL_OPENED = 'Modal_Opened';

// ─── Workflow (Batch 2) ──────────────────────────────────────────────────────
export const WORKFLOW_EDITED = 'Workflow_Edited';

// ─── Sensor (Batch 2) ────────────────────────────────────────────────────────
export const SENSOR_DELETED = 'Sensor_Deleted';
export const MANUAL_SENSOR_DELETED = 'ManualSensor_Deleted';
export const MANUAL_SENSOR_SAVED = 'ManualSensor_Saved';

// ─── Company / Workspace (Batch 2) ──────────────────────────────────────────
export const COMPANY_DELETED = 'Company_Deleted';
export const WORKSPACE_DELETED = 'Workspace_Deleted';

// ─── Store (Batch 2) ────────────────────────────────────────────────────────
export const STORE_FILTER_APPLIED = 'Store_FilterApplied';

// ─── Dashboard (Batch 2) ────────────────────────────────────────────────────
export const DASHBOARD_EVENT_FILTER = 'Dashboard_EventFilter';
export const ANALYTICS_DASHBOARD_OPEN = 'Analytics_DashboardOpen';

// ─── Elastic Table (Batch 2) ────────────────────────────────────────────────
export const ELASTIC_TABLE_FILTER = 'ElasticTable_FilterApplied';
export const ELASTIC_TABLE_DOWNLOAD = 'ElasticTable_Download';
export const ELASTIC_TABLE_EXPAND = 'ElasticTable_ExpandedView';
export const ELASTIC_TABLE_TIME_EDIT = 'ElasticTable_TimeRangeEdit';

// ─── Advanced Table (Batch 2) ───────────────────────────────────────────────
export const ADVANCED_TABLE_REF_CHANGE = 'AdvancedTable_ReferenceChange';
export const ADVANCED_TABLE_DOWNLOAD = 'AdvancedTable_Download';
export const ADVANCED_TABLE_TIME_EDIT = 'AdvancedTable_TimeRangeEdit';

// ─── Map Widget (Batch 2) ───────────────────────────────────────────────────
export const MAP_WIDGET_TAB_CHANGE = 'MapWidget_TabChange';

// ─── Floc Detector (Batch 2) ────────────────────────────────────────────────
export const FLOC_TIME_EDIT = 'FlocDetector_TimeRangeEdit';
export const FLOC_SAMPLE_TOGGLE = 'FlocDetector_SampleToggle';
export const FLOC_SAMPLE_FILTER = 'FlocDetector_SampleFilter';
export const FLOC_DOWNLOAD = 'FlocDetector_Download';
export const FLOC_GRAPH_SWITCH = 'FlocDetector_GraphSwitch';
export const FLOC_DELETE_SAMPLE = 'FlocDetector_DeleteSample';
export const FLOC_EXPAND = 'FlocDetector_ExpandedView';

// ─── Visualization (Batch 2) ────────────────────────────────────────────────
export const VISUALIZATION_PAGE_VIEW = 'Visualization_PageView';

// ─── Prop Interfaces ─────────────────────────────────────────────────────────
export interface DashboardFilterProps {
    filterType: string;
    timeRange?: string;
    dashboardId?: string;
}
export interface DashboardGraphProps {
    action: 'change_type' | 'change_timeframe' | 'expand';
    graphId?: string;
}
export interface EquipmentClickProps {
    equipmentId: string;
    equipmentType: string;
    assetId?: string;
}
export interface RemoteControlProps {
    equipmentId: string;
    equipmentType?: string;
    action: 'on' | 'off';
}
export interface FormulaProps {
    formulaId: string;
    formulaName?: string;
}
export interface InsightsFilterProps {
    filterType: 'priority' | 'status';
    filterValue: string;
}
export interface UserModuleProps {
    action: 'view' | 'add' | 'edit' | 'delete';
    targetUserId?: string;
}
export interface TriggerProps {
    triggerId: string;
    triggerName?: string;
}
export interface InventoryProps {
    inventoryId: string;
    previousValue?: number;
    newValue: number;
}
export interface EventBatchProps {
    eventId: string;
    eventName?: string;
}
export interface LifecycleProps {
    componentName: string;
    route?: string;
    duration?: number;
}
export interface ViewAsProps {
    targetUserId: string;
    targetUserName?: string;
}
export interface WidgetInteractionProps {
    widgetId: string;
    widgetName?: string;
    action?: string;
    chartType?: string;
    previousChartType?: string;
}
export interface DIInputProps {
    sensorTag: string;
    value: string;
    plantId?: string;
}
